import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import AdjustRemarkTextarea from 'components/admin/AdjustRemarkTextarea';
import BasePrompt from 'components/base/prompt/BasePrompt';
import { CustomTitleWithDropDown } from 'components/customer/CustomTitleWithDropDown';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import { CampaignType } from 'config/CustomEnums';
import { ToastType, defaultDelayTime } from 'models/NavBarModel';

import { createAction } from 'utils';

import './AdjustPrompt.scss';

function ApproveEarningRulePrompt({
  show,
  setShow,
  prefillData = {},
  customer = null,
}) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const { campaignList, customerDetail } = useSelector((state) => ({
    campaignList: state.campaignList?.allList,
    customerDetail: state.customerList?.customer,
  }));

  const [targetCustomer, setTargetCustomer] = useState();
  const [targetCampaign, setTargetCampaign] = useState();

  const [campaignRefreshDate, setCampaignRefreshDate] = useState(new Date());
  const [lastCampaignRefreshDate, setLastCampaignRefreshDate] =
    useState(campaignRefreshDate);

  const [remarks, setRemarks] = useState('');
  const [error, setError] = useState({});
  const [confirm, setConfirm] = useState(false);
  const [manualDisableButton, setManualDisableButton] = useState(false);

  useEffect(() => {
    if (show) {
      setTargetCustomer(customer);
      setTargetCampaign(prefillData?.targetCampaign || null);
      setError({});
      setConfirm(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  useEffect(() => {
    if (
      show &&
      (customerDetail?.pk === targetCustomer?.pk || !targetCustomer?.pk)
    ) {
      setTargetCustomer(customerDetail);
    }
  }, [customerDetail]);

  useEffect(() => {
    if (campaignList?.length === 1 && !targetCampaign?.pk) {
      setTargetCampaign(campaignList[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignList]);

  const getConfirmButtonDisabledStatus = () => {
    console.log('@values', {
      targetCustomer,
      targetCampaign,
    });
    if (confirm) {
      return false;
    }
    if (!targetCustomer?.pk || !targetCampaign?.pk) {
      return true;
    }
    return false;
  };

  const disabledButton =
    getConfirmButtonDisabledStatus() || manualDisableButton;

  const otherBody = () => {
    if (confirm) {
      let secretMobile = '';
      if (
        targetCustomer?.mobilePhoneNumberCountryCode &&
        targetCustomer?.mobilePhoneNumberSubscriberNumber
      ) {
        if (targetCustomer?.mobilePhoneNumberCountryCode === '86') {
          secretMobile = `${targetCustomer?.mobilePhoneNumberSubscriberNumber.slice(
            0,
            3,
          )}****${targetCustomer?.mobilePhoneNumberSubscriberNumber.slice(
            7,
            11,
          )}`;
        } else {
          const mobileLength =
            targetCustomer?.mobilePhoneNumberSubscriberNumber.length;
          secretMobile = `${
            targetCustomer?.mobilePhoneNumberSubscriberNumber[0]
          }${'*'.repeat(mobileLength - 2)}${
            targetCustomer?.mobilePhoneNumberSubscriberNumber[mobileLength - 1]
          }`;
        }
      }
      let data = {
        targetCustomer: targetCustomer?.pk,
        membershipId: targetCustomer?.membershipId,
        mobileNumber: secretMobile
          ? `+${targetCustomer?.mobilePhoneNumberCountryCode} ${secretMobile}`
          : '-',
        targetCampaign: targetCampaign?.pk
          ? `[ID: ${targetCampaign?.pk}] ${targetCampaign?.name}`
          : '-',
      };
      let fields = [
        [{ title: 'Membership ID', field: 'membershipId' }],
        [{ title: 'Mobile number', field: 'mobileNumber' }],
        [{ title: 'Earning campaign', field: 'targetCampaign' }],
      ];

      console.log('confirmed data', data);
      return (
        <>
          <div className="adjust-other-body-preview">
            <MembershipInfoCard
              title=""
              hideTitle={true}
              data={data}
              fields={fields}
            />
          </div>
        </>
      );
    }
    return (
      <>
        <div className="adjust-other-body">
          <CustomTitleWithDropDown
            customClass={'stamp-campaign-selector'}
            title="Earning campaign"
            defaultValue={{
              value: targetCampaign,
              label: targetCampaign?.pk
                ? targetCampaign?.type === CampaignType.stampCampaign
                  ? `[ID: ${targetCampaign?.earningRule?.pk}] ${targetCampaign?.earningRule?.name}`
                  : `[ID: ${targetCampaign?.pk}] ${targetCampaign?.name}`
                : targetCampaign?.name,
            }}
            setValue={(item) => {
              setTargetCampaign(item?.value);
            }}
            customItem={(item) => {
              return item?.pk
                ? item?.type === CampaignType.stampCampaign
                  ? `[ID: ${item?.earningRule?.pk}] ${item?.earningRule?.name}`
                  : `[ID: ${item?.pk}] ${item?.name}`
                : item?.name;
            }}
            showItemDescription={true}
            customItemDescription={(item) => {
              return item?.pk && item?.type === CampaignType.stampCampaign
                ? `[ID: ${item?.pk}] ${item?.name}`
                : '';
            }}
            source={campaignList || []}
            loadMoreAction={'campaignList/getCampaignList'}
            filterAction={'campaignList/getCampaignList'}
            defaultFilter={{
              relatedEarningRuleType: 'GPS_CHECK_IN,QR_CODE_SCANNING',
              ssoUid: customer?.ssoUid || targetCustomer?.ssoUid,
              reverse: true,
              skipUpdatePagedData: true,
              searchField: 'searchNameOrId',
            }}
            isReset={lastCampaignRefreshDate !== campaignRefreshDate}
            resetChange={() => {
              setLastCampaignRefreshDate(campaignRefreshDate);
            }}
            hideDeleteButton={true}
            placeholder={'Search by ID,  name'}
            errorName={'targetCampaign'}
            errors={{ targetCampaign: { message: error?.targetCampaign } }}
            usingErrorsMessage={true}
          />

          <CustomTitleLabel title="Admin remarks (optional)" />
          <AdjustRemarkTextarea remarks={remarks} setRemarks={setRemarks} />
        </div>
      </>
    );
  };

  const onClose = () => {
    if (confirm) {
      setConfirm(false);
      return;
    }
    setShow(false);
  };

  const showSuccessToast = () => {
    dispatch({
      type: 'navBars/updateState',
      payload: {
        saveDiscardToastShowing: {
          value: true,
          type: ToastType.operatedSuccessfully,
          delayTime: defaultDelayTime,
        },
      },
    });
  };

  return (
    <BasePrompt
      customClass={'approve-earningrule-prompt-container'}
      show={show}
      closeAction={() => {
        onClose();
      }}
      leftButton={{
        text: 'Cancel',
        action: () => onClose(),
      }}
      rightButton={{
        text: 'Confirm',
        disabled: disabledButton,
        action: () => {
          setError({});
          setManualDisableButton(true);

          let requestData = {
            id: targetCustomer?.pk,
            approveEarningRule: {
              campaignId: targetCampaign?.pk,
              earningRuleId: targetCampaign?.earningRule?.pk,
              isCheck: !confirm,
              remarks,
            },
          };
          console.log('confirm', requestData);
          if (!confirm) {
            dispatch(
              createAction('customerList/adjustCustomerRewards')({
                data: requestData,
                successCallback: () => {
                  setConfirm(true);
                  setManualDisableButton(false);
                },
                failureCallback: (errorMessage) => {
                  setError({ targetCampaign: errorMessage });
                  setManualDisableButton(false);
                },
              }),
            );
            return;
          }
          dispatch(
            createAction('customerList/adjustCustomerRewards')({
              data: requestData,
              successCallback: () => {
                setManualDisableButton(false);
                setShow(false);
                setRemarks('');
                showSuccessToast();
                history.push(location);
              },
              failureCallback: () => {
                setManualDisableButton(false);
              },
            }),
          );
        },
      }}
      title={confirm ? 'Confirmation' : `Approve earning rules`}
      tips={
        'Manually approve earning rules for customers. Only supports earning rules of the QR Code Scanning and GPS Check-in types, and these two earning rule types under stamp campaigns.'
      }
      otherBody={otherBody}
    />
  );
}
export default ApproveEarningRulePrompt;
